export default __webpack_public_path__ + "static/media/Group 7344.5a083cea.svg";